const STORAGE_KEY = "lv_utm_params";

// Captures utm_source / utm_medium / utm_campaign from the current URL (if present)
// and persists them for the rest of the session, so a form submitted several
// pages after the campaign link still carries the original attribution.
export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source");
  const utmMedium = params.get("utm_medium");
  const utmCampaign = params.get("utm_campaign");

  if (utmSource || utmMedium || utmCampaign) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        utmSource: utmSource || "",
        utmMedium: utmMedium || "",
        utmCampaign: utmCampaign || "",
      })
    );
  }
}

// Returns the hidden attribution fields to attach to any form submission payload.
export function getUtmParams() {
  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    stored = {};
  }
  return {
    utmSource: stored.utmSource || "",
    utmMedium: stored.utmMedium || "",
    utmCampaign: stored.utmCampaign || "",
    pageSource: window.location.pathname,
  };
}
